module.exports = __webpack_public_path__ + "static/media/bike_electric.7fe2a1a4.webp";